import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { useAppSelector } from '../../../redux/store';
import { TransitionEndingAnimation } from './transitionEndingAnimation';
import { TransitionLoadingAnimation } from './transitionLoadingAnimation';
export const TransitionAnimationContainer = () => {
    const transition = useAppSelector((state) => state.transitionAnimation.transition);
    if (!transition) {
        return null;
    }
    switch (transition.type) {
        case 'loading': {
            return _jsx(TransitionLoadingAnimation, { transition: transition });
        }
        case 'ending': {
            return _jsx(TransitionEndingAnimation, { transition: transition });
        }
    }
};
